import React, { useEffect, useState, useMemo } from 'react';
import {
  Grid,
  TextField,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Tooltip,
  Typography,
  Paper,
  IconButton,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useSelector, useDispatch } from 'react-redux';
import {
  setData,
  markAttendence,
  selectAll,
  setbatchId,
  removeAll,
  addAttendence,
} from 'reducer/attendenceSlice';
import { updateAttendence, fetchAttendanceByBatchId } from 'thunks/attendenceSliceThunks/thunks';
import { fetchBatchData } from 'thunks/trainingThunks/thunk';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import TableComponent from 'Component/Table';

import { TrainingRequests } from 'requests/TrainingRequests';
import rootAxios from 'requests/rootAxios';
import Layout from 'Component/Layouts/layout';
import useIsLearningTrainer from 'hooks/useIsLearningTrainer';
import useIsLearningSuperUser from 'hooks/useIsLearningSuperUser';
import useIsLearningManager from 'hooks/useIsLearningManager';
import useIsClusterManager from 'hooks/useIsClusterManager';
export default function MarkAttendance() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [count, setCount] = useState(10);
  const [selectedDate, setSelectedDate] = useState('');
  const [attendenceMarking, setAttendenceMarking] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [selectAllClicked, setSelectAllClicked] = useState(false);
  const [openReasonDialog, setOpenReasonDialog] = useState(false);
  const [currentEmp, setCurrentEmp] = useState(null);
  const [reason, setReason] = useState('');
  const [reasonType, setReasonType] = useState('');
  const [isLastDay, setIsLastDay] = useState(false);
  const [allAttendanceMarked, setAllAttendanceMarked] = useState(false);
  const batchId = useMemo(() => queryParams.get('batchId'), [location]);
  const dispatch = useDispatch();
  const { data: attendenceData } = useSelector((state) => state.attendenceSlice);
  const { trainingType } = useSelector((state) => state.trainingSlice);
  const isTrainer = useIsLearningTrainer();
  const isLearningSuperUser = useIsLearningSuperUser();
  const isLearnManager = useIsLearningManager();
  const isClusterManager = useIsClusterManager();
  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
    setTableData([]);
  };

  // Function to apply prefilled data to Redux store
  const applyPrefilledData = (selectedDate) => {
    if (!attendenceData?.data?.attendance || !selectedDate) return;

    const selectedAttendance = attendenceData.data.attendance.find(
      (att) => att.date === selectedDate
    );
    if (!selectedAttendance) return;

    // Get all employees who don't have data for this date
    const employeesWithoutData = attendenceData.data.batchTrainees.filter(
      (emp) =>
        !selectedAttendance.present.includes(emp.id) && !selectedAttendance.absent.includes(emp.id)
    );

    console.log(
      `Applying prefilled data for date ${selectedDate}. Employees without data:`,
      employeesWithoutData.length
    );

    // Apply prefilling for each employee without data
    employeesWithoutData.forEach((emp) => {
      const currentDate = new Date(selectedDate);
      const previousAttendance = attendenceData.data.attendance.find((prevAttendance) => {
        const prevDate = new Date(prevAttendance.date);
        return (
          prevDate < currentDate &&
          (prevAttendance.present.includes(emp.id) || prevAttendance.absent.includes(emp.id))
        );
      });

      if (previousAttendance) {
        if (previousAttendance.present.includes(emp.id)) {
          // Prefill as present
          console.log(`Auto-prefilling employee ${emp.id} as present for date ${selectedDate}`);
          dispatch(
            addAttendence({
              date: selectedDate,
              emp: emp.id,
              present: true,
            })
          );
        } else if (previousAttendance.absent.includes(emp.id)) {
          // Prefill as absent with reason
          const reason =
            previousAttendance.absentReasons && previousAttendance.absentReasons[String(emp.id)]
              ? previousAttendance.absentReasons[String(emp.id)]
              : '';

          console.log(
            `Auto-prefilling employee ${emp.id} as absent for date ${selectedDate} with reason: ${reason}`
          );
          dispatch(
            addAttendence({
              date: selectedDate,
              emp: emp.id,
              present: false,
              reason: reason,
            })
          );
        }
      }
    });
  };

  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };

  const handleReasonTypeChange = (event) => {
    setReasonType(event.target.value);
    if (event.target.value !== 'Other') {
      setReason('');
    }
  };

  const handleCloseReasonDialog = () => {
    setOpenReasonDialog(false);
    setReasonType('');
    setReason('');
  };

  const handleConfirmReason = () => {
    if (currentEmp && reasonType) {
      let reasonValue = reasonType === 'Other' ? reason : reasonType;
      dispatch(
        addAttendence({
          date: selectedDate,
          emp: currentEmp,
          present: false,
          reason: reasonValue,
        })
      );
    }
    handleCloseReasonDialog();
  };

  const handleAttendence = async () => {
    setAttendenceMarking(true);
    // if any case if NA or not marked show error to user & return.

    let filtered = attendenceData.data.attendance.filter((data) => data.date === selectedDate);
    console.log('attendenceData.data.attendance', filtered);
    if (
      filtered[0]?.present?.length + filtered[0]?.absent?.length !==
      filtered[0]?.unmarkedTrainees?.length
    ) {
      toast.error(`Please mark attendance for all employees for date ${selectedDate}`, {
        theme: 'colored',
      });
      setAttendenceMarking(false);
      return;
    }

    try {
      await TrainingRequests.markAttendenceRequest({
        batchId: batchId,
        attendance: filtered,
      });
      toast.success('Attendance Marked.', {
        theme: 'colored',
      });

      if (isLastDay) {
        // Re-fetch from server to get accurate state before checking all-absent condition
        const fetchResult = await dispatch(fetchAttendanceByBatchId(batchId));
        const latestAttendance = fetchResult.payload?.data?.attendance;

        if (isAllEmployeesAbsentAllDaysStatus(latestAttendance)) {
          toast.error('All employees are absent all days', {
            theme: 'colored',
          });
          // update keys
          await rootAxios
            .post(`/user/update-batch-keys`, {
              batchId: batchId,
              certificatesSent: true,
              attendencePending: false,
              feedbackPending: false,
            })
            .then((res) => {
              navigate(`/training/AllTrainings`);
            })
            .catch((err) => {
              console.log('err', err);
            });
          return;
        } else {
          // Check training type - for corrective-training, redirect to branch-info instead of feedback
          if (
            trainingType?.toLowerCase() === 'corrective-training' ||
            trainingType?.toLowerCase() === 'corrective_training'
          ) {
            navigate(`/attendance/branch-info?batchId=${batchId}`);
          } else {
            // Navigate to feedback page if it's the last day
            navigate(`/attendance/feedback?batchId=${batchId}`);
          }
        }
      } else {
        // Re-fetch from server so allAttendanceMarked is based on actual saved data,
        // not the local carry-forward Redux state
        await dispatch(fetchAttendanceByBatchId(batchId));
      }
    } catch (error) {
      toast.error(`Failed to Mark Attendance: ${error.message}`, {
        theme: 'colored',
      });
    }
    setAttendenceMarking(false);
  };

  const handleBackToAttendance = () => {
    navigate(`/attendance?batchId=${batchId}`);
  };

  const renderAction = (row, date, notAllowed) => {
    let status = row[date] === 'true' ? 'Present' : row[date] === 'false' ? 'Absent' : 'NA';
    const isDisabled = false;
    const isDateSelected = date === selectedDate;

    return (
      <Tooltip
        title={isDisabled ? 'Not allowed by RM' : !isDateSelected ? 'Select date first' : ''}
        arrow
      >
        <span>
          <Select
            value={status}
            disabled={isDisabled || !isDateSelected}
            onChange={(e) => {
              const newStatus = e.target.value;
              if (newStatus === 'Absent') {
                setCurrentEmp(row.batchTrainees);
                setOpenReasonDialog(true);
              } else {
                dispatch(
                  addAttendence({
                    date: date,
                    emp: row.batchTrainees,
                    present: newStatus === 'Present',
                  })
                );
              }
            }}
            sx={{ minWidth: 50 }}
          >
            <MenuItem value="NA">NA</MenuItem>
            <MenuItem value="Present">Present</MenuItem>
            <MenuItem value="Absent">Absent</MenuItem>
          </Select>
        </span>
      </Tooltip>
    );
  };

  useEffect(() => {
    if (batchId) {
      dispatch(setbatchId(batchId));
      dispatch(fetchAttendanceByBatchId(batchId));
      dispatch(fetchBatchData({ dispatch, batchId }));
    }
  }, [batchId, dispatch]);

  // Apply prefilled data when selected date changes
  useEffect(() => {
    if (selectedDate && attendenceData?.status === 'success') {
      // Small delay to ensure Redux store is updated
      const timer = setTimeout(() => {
        applyPrefilledData(selectedDate);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [selectedDate, attendenceData?.status]);

  useEffect(() => {
    if (attendenceData?.status === 'success') {
      // Auto-select first date if no date is selected
      if (!selectedDate && attendenceData.data.attendance.length > 0) {
        setSelectedDate(attendenceData.data.attendance[0].date);
        return; // Exit early, let the next useEffect run with the selected date
      }

      let tempColumns = [
        { label: 'EmpID', field: 'batchTrainees' },
        { label: 'Name', field: 'name' },
      ];

      attendenceData.data.attendance.forEach((elem) => {
        const { notAllowed } = elem;
        if (selectedDate && elem.date === selectedDate) {
          tempColumns.push({
            label: elem.date,
            field: elem.date,
            render: (row) => renderAction(row, elem.date, notAllowed),
          });
        } else {
          tempColumns.push({
            label: elem.date,
            field: elem.date,
            render: (row) => {
              // Use the row data which already has the correct status (including prefilled absent)
              const status = row[elem.date];
              if (status === 'true') {
                return <span style={{ color: 'green', fontWeight: 'bold' }}>Present</span>;
              } else if (status === 'false') {
                return <span style={{ color: 'red', fontWeight: 'bold' }}>Absent</span>;
              }
              return <span style={{ color: 'gray' }}>NA</span>;
            },
          });
        }
      });

      setColumns([...tempColumns]);

      let tempDataArray = attendenceData.data.batchTrainees.map((elem) => {
        let rowData = {
          [tempColumns[0].field]: elem.id,
          [tempColumns[1].field]: elem.name,
        };
        attendenceData.data.attendance.forEach((attendance) => {
          const isPresent = attendance.present.includes(elem.id);
          const isAbsent = attendance.absent.includes(elem.id);

          if (attendance.date === selectedDate) {
            // For the selected date (dropdown), prefill based on previous attendance patterns
            if (isPresent) {
              rowData[attendance.date] = 'true';
            } else if (isAbsent) {
              rowData[attendance.date] = 'false';
            } else {
              // Check if employee was present or absent on any previous date and prefill accordingly
              const currentDate = new Date(attendance.date);
              const previousAttendance = attendenceData.data.attendance.find((prevAttendance) => {
                const prevDate = new Date(prevAttendance.date);
                return (
                  prevDate < currentDate &&
                  (prevAttendance.present.includes(elem.id) ||
                    prevAttendance.absent.includes(elem.id))
                );
              });

              if (previousAttendance) {
                if (previousAttendance.present.includes(elem.id)) {
                  rowData[attendance.date] = 'true';
                } else if (previousAttendance.absent.includes(elem.id)) {
                  rowData[attendance.date] = 'false';
                  // Preserve the absent reason from the previous attendance
                  if (
                    previousAttendance.absentReasons &&
                    previousAttendance.absentReasons[String(elem.id)]
                  ) {
                    rowData.reason = previousAttendance.absentReasons[String(elem.id)];
                  }
                }
              } else {
                rowData[attendance.date] = 'NA';
              }
            }
          } else {
            // For other dates (viewing only), show actual API data only - no prefilling
            rowData[attendance.date] = isPresent ? 'true' : isAbsent ? 'false' : 'NA';
          }

          // Get reason from absentReasons object for this specific employee
          // For selected date, use current attendance reason or prefilled reason
          if (attendance.date === selectedDate) {
            if (attendance.absentReasons && attendance.absentReasons[String(elem.id)]) {
              rowData.reason = attendance.absentReasons[String(elem.id)];
            } else if (rowData.reason) {
              // Use the prefilled reason if available
              // (already set in the prefilling logic above)
            } else {
              rowData.reason = '';
            }
          } else {
            // For other dates, use the current attendance reason
            rowData.reason =
              attendance.absentReasons && attendance.absentReasons[String(elem.id)]
                ? attendance.absentReasons[String(elem.id)]
                : '';
          }
        });
        return rowData;
      });

      setTableData([...tempDataArray]);
      setCount(tempDataArray.length);

      // Check if all attendance is marked
      const allDatesMarked = attendenceData.data.attendance.every(
        (attendance) => attendance.present.length > 0 || attendance.absent.length > 0
      );
      setAllAttendanceMarked(allDatesMarked);

      const dates = attendenceData.data.attendance.map((a) => new Date(a.date));
      const selectedDateObj = new Date(selectedDate);
      const isLastTrainingDay = dates.every((date) => date <= selectedDateObj);
      setIsLastDay(isLastTrainingDay);
    }
  }, [attendenceData, selectedDate, toggled, selectAllClicked]);

  // Get available dates from attendance data
  const getAvailableDates = () => {
    if (!attendenceData?.data?.attendance) return [];
    return attendenceData.data.attendance.map((att) => att.date);
  };
  const isAllEmployeesAbsentAllDaysStatus = (data) => {
    console.log('Attendance Test data', data);
    if (!data || data.length === 0) return false;
    const status = data.every(
      (record) => record?.absent?.length === record?.unmarkedTrainees?.length
    );
    console.log('Attendance Test data', JSON.stringify(data), status);
    return status;
  };
  const isMyAllEmployeesAbsentAllDays = () => {
    let attendanceRecords = attendenceData?.data?.attendance;
    return isAllEmployeesAbsentAllDaysStatus(attendanceRecords);
  };
  console.log('allEmployeesAbsent', isMyAllEmployeesAbsentAllDays());
  const todayisPastLastmarkDay = () => {
    // Check if current role is trainer
    if (isLearningSuperUser || isLearnManager || isClusterManager) {
      return false;
    }

    // Check if attendance data is available
    if (!attendenceData?.data?.attendance || attendenceData.data.attendance.length === 0) {
      return false;
    }

    // Get all attendance dates and find the last one
    const attendanceDates = attendenceData.data.attendance.map((att) => new Date(att.date));
    const lastAttendanceDate = new Date(Math.max(...attendanceDates));

    // Get current date and set its time to the beginning of the day (midnight)
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Compare today's date with the last attendance date.
    // By setting today's time to midnight, this comparison will now return false
    // if lastAttendanceDate is also today, and true only if today is a future day.
    return today > lastAttendanceDate;
  };
  return (
    <Layout>
      <Box sx={{ padding: '20px' }}>
        {/* Header with Back Button */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px',
            gap: 2,
          }}
        >
          <IconButton
            onClick={handleBackToAttendance}
            sx={{
              backgroundColor: '#f5f5f5',
              '&:hover': { backgroundColor: '#e0e0e0' },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5" component="h1">
            Mark Attendance - Batch {batchId}
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {/* Date Selection */}
          <Grid item xs={12}>
            <Paper sx={{ padding: '20px', marginBottom: '20px' }}>
              <Typography variant="h6" gutterBottom>
                Select Date for Attendance
              </Typography>
              <FormControl fullWidth sx={{ maxWidth: 300 }}>
                <InputLabel id="date-select-label">Date</InputLabel>
                <Select
                  labelId="date-select-label"
                  value={selectedDate}
                  label="Date"
                  onChange={handleDateChange}
                >
                  {getAvailableDates().map((date) => (
                    <MenuItem key={date} value={date}>
                      {date}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Paper>
          </Grid>
          {todayisPastLastmarkDay() && (
            <Grid item xs={12}>
              <Paper
                sx={{
                  padding: '16px',
                  marginBottom: '20px',
                  backgroundColor: '#fff3cd',
                  border: '1px solid #ffeaa7',
                  borderRadius: '8px',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: '#856404',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    ⚠️ Last day has already passed. Please reach out to admin to update attendance.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          )}
          {/* Attendance Table */}
          {selectedDate && tableData.length > 0 && (
            <Grid item xs={12}>
              <Paper sx={{ padding: '20px' }}>
                <Typography variant="h6" gutterBottom>
                  Mark Attendance for {selectedDate}
                </Typography>
                <TableComponent
                  tableData={tableData}
                  setTableData={setTableData}
                  columns={columns}
                  tableName={'Attendance List'}
                  count={tableData?.length}
                  rowClickedKey={'batchTrainees'}
                  useWholeRowClicked={false}
                />
              </Paper>
            </Grid>
          )}

          {/* Action Buttons */}
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button variant="outlined" onClick={handleBackToAttendance}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleAttendence}
                disabled={
                  !selectedDate ||
                  tableData.length === 0 ||
                  attendenceMarking ||
                  todayisPastLastmarkDay()
                }
                startIcon={attendenceMarking ? <CircularProgress size={20} /> : null}
              >
                {attendenceMarking ? 'Submitting...' : 'Submit Attendance'}
              </Button>
              <Tooltip
                title={
                  !selectedDate
                    ? 'Please select a date first'
                    : !tableData.length
                      ? 'No attendance data available'
                      : !allAttendanceMarked
                        ? 'Please mark attendance for all training days before submitting feedback'
                        : 'Ready to submit feedback'
                }
                arrow
              >
                <span>
                  <Button
                    variant="contained"
                    onClick={() => navigate(`/attendance/feedback?batchId=${batchId}`)}
                    disabled={
                      !selectedDate ||
                      tableData.length === 0 ||
                      !allAttendanceMarked ||
                      isMyAllEmployeesAbsentAllDays()
                    }
                  >
                    Submit Feedback
                  </Button>
                </span>
              </Tooltip>
            </Box>
          </Grid>
        </Grid>

        {/* Reason Dialog */}
        <Dialog open={openReasonDialog} onClose={handleCloseReasonDialog}>
          <DialogTitle>Reason for Absence</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please select or enter the reason for marking this employee as absent.
            </DialogContentText>
            <FormControl fullWidth margin="dense">
              <InputLabel id="reason-type-label">Reason Type</InputLabel>
              <Select
                labelId="reason-type-label"
                id="reason-type"
                value={reasonType}
                label="Reason Type"
                onChange={handleReasonTypeChange}
              >
                <MenuItem value="Absconding">Absconding</MenuItem>
                <MenuItem value="Did Not Join">Did Not Join</MenuItem>
                <MenuItem value="Resigned">Resigned</MenuItem>
                <MenuItem value="Re-Joined in last 3 months">Re-Joined in last 6 months</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </FormControl>
            {reasonType === 'Other' && (
              <TextField
                margin="dense"
                id="name"
                label="Specify Reason"
                type="text"
                fullWidth
                variant="standard"
                value={reason}
                onChange={handleReasonChange}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseReasonDialog}>Cancel</Button>
            <Button
              onClick={handleConfirmReason}
              disabled={reasonType === '' || (reasonType === 'Other' && reason === '')}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Layout>
  );
}
